const startOfDay = (date) => {
  const value = new Date(date);
  value.setHours(0, 0, 0, 0);
  return value;
};

const daysBetween = (later, earlier) =>
  Math.floor((startOfDay(later).getTime() - startOfDay(earlier).getTime()) / 86400000);

/**
 * Groups activity items into: recent | yesterday | lastWeek | last30Days | older
 */
export const groupRecentByDate = (items = [], now = new Date()) => {
  const buckets = {
    recent: [],
    yesterday: [],
    lastWeek: [],
    last30Days: [],
    older: []
  };

  [...items].forEach((item) => {
    const updated = new Date(item.updatedAt || item.UpdatedAt || 0);
    if (Number.isNaN(updated.getTime())) {
      buckets.older.push(item);
      return;
    }

    const diff = daysBetween(now, updated);
    if (diff <= 0) buckets.recent.push(item);
    else if (diff === 1) buckets.yesterday.push(item);
    else if (diff <= 7) buckets.lastWeek.push(item);
    else if (diff <= 30) buckets.last30Days.push(item);
    else buckets.older.push(item);
  });

  return [
    { key: 'recent', items: buckets.recent },
    { key: 'yesterday', items: buckets.yesterday },
    { key: 'lastWeek', items: buckets.lastWeek },
    { key: 'last30Days', items: buckets.last30Days },
    { key: 'older', items: buckets.older }
  ].filter((group) => group.items.length > 0);
};
